import { useContext } from "react";
import { ToastContext } from "../contexts/toastContext";
import { ToastContextType } from "../../types/toast";

export const useToast = () => {
  const context = useContext(ToastContext) as ToastContextType;
  return context;
};
